<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="9" md="6">
        <div align="center">
          <v-img :src="require('@/assets/modalLogb.png')" class="responsive-logo"></v-img>
        </div><br /><br />
        <v-flex>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Login form</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field outlined prepend-inner-icon="mdi-account" name="login" label="Login" v-model="email"
                  type="email"></v-text-field>
                <v-text-field outlined id="password" prepend-inner-icon="mdi-lock" name="password" v-model="password"
                  label="Password" type="password"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" type="submit" @click="login">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog v-model="dialog" hide-overlay persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            loading...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      Login failed please try again
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    email: "",
    password: "",
    dialog: false,
    snackbar: false,
    timeout: 2000,
  }),
  methods: {
    login() {
      this.dialog = true;
      this.$store.dispatch("login", {
        email: this.email,
        password: this.password,
      }).then(() => {

      }).catch((err) => {
        this.dialog = false;
        this.snackbar = true;
      });
    },
  },
};
</script>

<style >
.responsive-logo {
  width: 70%;
  height: auto;
}
</style>